// extracted by mini-css-extract-plugin
export var ar16_9 = "ImagePlaceholder-module--ar-16_9--27e49";
export var base = "ImagePlaceholder-module--base--fc087";